/**
 * Set true to show numbered debug badges (1–18) on each background question.
 */
window.FullPageLandingDebug = false;

/**
 * Set true to make floating background questions clickable (mouse/touch only).
 */
window.FullPageLandingLinks = false;

/**
 * Entrance + parallax + float tuning.
 * Entrance fades by layer: 1 (front) first, then 2, 3, 4 — opacity only.
 */
window.FullPageLandingMotion = {
  entranceDuration: 700, // ms fade per layer
  entranceStagger: 280, // ms before the next layer starts fading in
  // gentle thought-bubble float (disabled when amplitude is 0)
  floatAmplitude: 6, // px vertical bob
  floatAmplitudeX: 2.5, // px horizontal drift
  floatDuration: 6500, // ms per full float cycle (higher = smoother/slower)
  floatEase: 0.06, // lerp toward target each frame (lower = silkier, higher = snappier)
  // parallax: scrollY * velocity → translateY (px). Front should be fastest.
};

/**
 * Pre-defined depth layers (scale + opacity + parallax depth + scroll velocity).
 * 1 = front-most (fades in first, fastest parallax) … 4 = furthest back.
 * Tweak `velocity` to control how fast each layer moves on scroll.
 */
window.FullPageLandingLayers = {
  1: { scale: 1, opacity: 0.9, depth: 1, velocity: 0.55 }, // front
  2: { scale: 0.95, opacity: 0.7, depth: 0.85, velocity: 0.38 }, // near
  3: { scale: 0.75, opacity: 0.5, depth: 0.45, velocity: 0.22 }, // mid
  4: { scale: 0.68, opacity: 0.3, depth: 0.3, velocity: 0.1 }, // far
};

/**
 * Editable relative point map for background questions.
 * x/y = % of section; position maps to the CENTER of each question’s text.
 * layer = key from FullPageLandingLayers (1–4).
 * mobile = when true, this point stays active at md and below; others hide.
 * mobile_x / mobile_y = optional % offsets added to x/y on mobile only.
 */
window.FullPageLandingPoints = [
  // top band (under header)
  { x: 10, y: 0, layer: 3 }, // 1
  { x: 38, y: 32, layer: 1 }, // 2
  { x: 58, y: 7, layer: 4, mobile: true, mobile_x: 23, mobile_y: -8 }, // 3
  { x: 82, y: 5, layer: 2 }, // 4

  // upper mid — left / center flanks around headline
  { x: 18, y: 30, layer: 4, mobile: true }, // 5
  { x: 32, y: 20, layer: 3 }, // 6
  { x: 51, y: 42, layer: 1, mobile: true, mobile_x: 12, mobile_y: 0 }, // 7
  { x: 68, y: 26, layer: 3 }, // 8

  // mid flanks (beside hero body)
  { x: 15, y: 48, layer: 2 }, // 9
  { x: 84, y: 34, layer: 1, mobile: true, mobile_x: 8, mobile_y: 12 }, // 10
  { x: 90, y: 50, layer: 4 }, // 11
  { x: 24, y: 64, layer: 3, mobile: true, mobile_x: -5, mobile_y: 45 }, // 12

  // lower mid
  { x: 12, y: 78, layer: 1, mobile: true, mobile_x: 30, mobile_y: 48 }, // 13
  { x: 50, y: 53, layer: 2 }, // 14
  { x: 78, y: 58, layer: 2 }, // 15

  // bottom band
  { x: 35, y: 84, layer: 3 }, // 16
  { x: 64, y: 80, layer: 4 }, // 17
  { x: 74, y: 70, layer: 1 }, // 18
  { x: 88, y: 80, layer: 4 }, // 19
];

(function () {
  // Bootstrap `media-breakpoint-down(md)` — on mobile, only points with mobile: true stay active.
  var floatingQuestionsMq = window.matchMedia("(max-width: 767.98px)");
  var reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  var items = [];
  var rafId = 0;
  var entranceStartedAt = 0;
  var listenersBound = false;

  function parseItems(raw) {
    if (!raw) {
      return [];
    }
    try {
      var items = JSON.parse(raw);
      if (!Array.isArray(items)) {
        return [];
      }
      return items
        .map(function (item) {
          if (typeof item === "string") {
            return { title: item, url: "" };
          }
          if (!item || typeof item !== "object") {
            return null;
          }
          return {
            title: item.title || "",
            url: item.url || "",
          };
        })
        .filter(function (item) {
          return item && item.title;
        });
    } catch (e) {
      return [];
    }
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function resolvePoint(point, isMobile) {
    var layers = window.FullPageLandingLayers || {};
    var layer = layers[point.layer] ||
      layers[4] || {
        scale: 1,
        opacity: 1,
        depth: 1,
        velocity: 0.2,
      };
    var x = point.x;
    var y = point.y;

    // Optional mobile-only position tweaks (added to base x/y).
    if (isMobile && point.mobile) {
      if (typeof point.mobile_x === "number") {
        x += point.mobile_x;
      }
      if (typeof point.mobile_y === "number") {
        y += point.mobile_y;
      }
    }

    return {
      x: x,
      y: y,
      scale: layer.scale,
      opacity: layer.opacity,
      depth: layer.depth,
      velocity: typeof layer.velocity === "number" ? layer.velocity : 0.2,
      layer: point.layer,
      mobile: !!point.mobile,
    };
  }

  /**
   * Pair each point with its question item by original index.
   * On mobile, only include points marked mobile: true.
   */
  function getActivePointEntries(questionItems) {
    var points = window.FullPageLandingPoints || [];
    var isMobile = floatingQuestionsMq.matches;
    var entries = [];

    for (var i = 0; i < points.length; i++) {
      if (isMobile && !points[i].mobile) {
        continue;
      }
      var item = questionItems[i];
      if (!item || !item.title) {
        continue;
      }
      entries.push({
        point: resolvePoint(points[i], isMobile),
        item: item,
        index: i + 1,
      });
    }

    return entries;
  }

  function getMotion() {
    return Object.assign(
      {
        entranceDuration: 700,
        entranceStagger: 280,
        floatAmplitude: 6,
        floatAmplitudeX: 2.5,
        floatDuration: 6500,
        floatEase: 0.06,
      },
      window.FullPageLandingMotion || {},
    );
  }

  function layerEntranceOrder(layer) {
    var n = parseInt(layer, 10);
    return isNaN(n) || n < 1 ? 4 : n;
  }

  function floatEnabled(motion) {
    return (
      !reduceMotion &&
      ((motion.floatAmplitude || 0) > 0 || (motion.floatAmplitudeX || 0) > 0)
    );
  }

  function applyItem(item, scrollY, now) {
    var motion = getMotion();
    var entrance = 1;

    if (!reduceMotion) {
      var order = layerEntranceOrder(item.layer) - 1; // 0 = front first
      var start = entranceStartedAt + order * motion.entranceStagger;
      var t = (now - start) / motion.entranceDuration;
      if (t <= 0) {
        entrance = 0;
      } else if (t < 1) {
        entrance = easeOutCubic(t);
      }
    }

    // Parallax relative to this panel so panel 2 isn't pre-offset when it enters view.
    var panelTop = item.panelRoot
      ? item.panelRoot.getBoundingClientRect().top
      : 0;
    var parallax = reduceMotion ? 0 : panelTop * item.velocity;
    var targetX = 0;
    var targetY = 0;

    if (floatEnabled(motion) && entrance > 0) {
      var period = motion.floatDuration || 6500;
      // Smoothstep the sine so direction changes feel softer at the peaks.
      var wave = (now / period) * Math.PI * 2 + item.floatPhase;
      var waveX = (now / (period * 1.45)) * Math.PI * 2 + item.floatPhase * 1.7;
      var sinY = Math.sin(wave);
      var sinX = Math.sin(waveX);
      targetY = sinY * Math.abs(sinY) * (motion.floatAmplitude || 0) * entrance;
      targetX =
        sinX * Math.abs(sinX) * (motion.floatAmplitudeX || 0) * entrance;
    }

    var ease = Math.min(Math.max(motion.floatEase || 0.06, 0.01), 1);
    item.floatX += (targetX - item.floatX) * ease;
    item.floatY += (targetY - item.floatY) * ease;

    // Outer el stays centered; motionEl gets GPU-friendly pixel transforms only.
    item.motionEl.style.transform =
      "translate3d(" +
      item.floatX.toFixed(2) +
      "px, " +
      (parallax + item.floatY).toFixed(2) +
      "px, 0) scale(" +
      item.scale +
      ")";
    item.textEl.style.opacity = String(item.opacity * entrance);
  }

  function tick(now) {
    var motion = getMotion();

    for (var i = 0; i < items.length; i++) {
      applyItem(items[i], 0, now);
    }

    // Keep looping for float; scroll/resize also poke requestTick.
    if (floatEnabled(motion)) {
      rafId = requestAnimationFrame(tick);
    } else {
      var allIn = true;
      if (!reduceMotion) {
        for (var j = 0; j < items.length; j++) {
          var order = layerEntranceOrder(items[j].layer) - 1;
          var doneAt =
            entranceStartedAt +
            order * motion.entranceStagger +
            motion.entranceDuration;
          if (now < doneAt) {
            allIn = false;
            break;
          }
        }
      }
      rafId = allIn ? 0 : requestAnimationFrame(tick);
    }
  }

  function requestTick() {
    if (!rafId) {
      rafId = requestAnimationFrame(tick);
    }
  }

  function placeQuestionsInRoot(root, panelIndex) {
    var layerEl = root.querySelector(".background-questions__layer");
    if (!layerEl) {
      return;
    }

    var debug = !!window.FullPageLandingDebug;
    var linksEnabled = !!window.FullPageLandingLinks;
    var questionItems = parseItems(root.getAttribute("data-items"));
    var entries = getActivePointEntries(questionItems);
    var panelRoot = root.closest(".landing-panel") || root;

    layerEl.innerHTML = "";
    root.classList.toggle("is-debug", debug);
    root.classList.toggle("has-links", linksEnabled);

    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var point = entry.point;
      var item = entry.item;
      var n = entry.index;
      // Non-focusable span (not <a>) so audits don't flag focusable content in aria-hidden.
      // Mouse/touch navigation only — no tabindex, not in the accessibility tree (parent aria-hidden).
      var el = document.createElement("span");
      el.className = "background-question";
      el.dataset.index = String(n);
      el.dataset.layer = String(point.layer || "");
      el.dataset.depth = String(point.depth);
      el.style.left = point.x + "%";
      el.style.top = point.y + "%";

      if (linksEnabled && item.url) {
        el.classList.add("is-linked");
        el.dataset.url = item.url;
        el.addEventListener("click", function (event) {
          var url = event.currentTarget.dataset.url;
          if (url) {
            window.location.assign(url);
          }
        });
      }

      var motionEl = document.createElement("span");
      motionEl.className = "background-question__motion";

      var text = document.createElement("span");
      text.className = "background-question__text";
      text.textContent = item.title;
      motionEl.appendChild(text);

      if (debug) {
        var badge = document.createElement("span");
        badge.className = "background-question__debug";
        badge.textContent = String(n);
        motionEl.appendChild(badge);
      }

      el.appendChild(motionEl);
      layerEl.appendChild(el);

      items.push({
        el: el,
        motionEl: motionEl,
        textEl: text,
        panelRoot: panelRoot,
        index: n,
        layer: point.layer,
        scale: point.scale || 1,
        opacity: point.opacity,
        velocity: point.velocity,
        floatX: 0,
        floatY: 0,
        // Stagger phases so questions don't bob in sync (offset per panel too).
        floatPhase:
          n * 0.7 + layerEntranceOrder(point.layer) * 0.45 + panelIndex * 1.3,
      });
    }
  }

  function clearQuestions() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = 0;
    }

    items = [];
    entranceStartedAt = 0;

    document
      .querySelectorAll(".background-questions__layer")
      .forEach(function (layerEl) {
        layerEl.innerHTML = "";
      });

    document.querySelectorAll(".background-questions").forEach(function (root) {
      root.classList.remove("is-debug", "has-links");
    });
  }

  function placeQuestions(section) {
    items = [];
    section
      .querySelectorAll(".background-questions")
      .forEach(function (root, panelIndex) {
        placeQuestionsInRoot(root, panelIndex);
      });

    entranceStartedAt = performance.now();
    requestTick();
  }

  function onScrollOrResize() {
    if (!items.length) {
      return;
    }
    requestTick();
  }

  function bindListeners() {
    if (listenersBound) {
      return;
    }

    listenersBound = true;
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });
  }

  function startFloatingQuestions() {
    clearQuestions();

    document
      .querySelectorAll("section.full_page_landing")
      .forEach(placeQuestions);

    bindListeners();
  }

  function syncFloatingQuestions() {
    startFloatingQuestions();
  }

  function init() {
    syncFloatingQuestions();

    if (typeof floatingQuestionsMq.addEventListener === "function") {
      floatingQuestionsMq.addEventListener("change", syncFloatingQuestions);
    } else if (typeof floatingQuestionsMq.addListener === "function") {
      floatingQuestionsMq.addListener(syncFloatingQuestions);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
